export default __webpack_public_path__ + "static/media/medicine.9ccaa9f3.svg";